export const dateToUnixSeconds = (datetime) => new Date(`1970-01-01 ${datetime.getHours()}:${datetime.getMinutes()}:${datetime.getSeconds()}`).getTime();
export const timeToUnixSeconds = (time) => new Date(`1970-01-01 ${time}`).getTime();
export const getFormatDate = (date) => {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  // To avoid method toISOString() convert 09/12 to 08/12 for GMT+01
  // This converts 09/12 00:00:00 GMT+01 to 08/12, so filter is left in an inconsistent state
  // This prevents the date of the data-picker from being different with the date we send to server
  return new Date(Date.UTC(year, month, day)).toISOString().substring(0, 10);
};
export const getTimeFormat = (date) => {
  const hour = date.getHours();
  const minute = date.getMinutes();
  const seconds = date.getSeconds();
  return `${hour}:${minute}:${seconds}`;
};
